import React from 'react';
import { Auth } from 'aws-amplify';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { Link } from 'react-router-dom';

import StatusButton from '../../components/StatusButton';
import Input from '../../components/form/Input';
import { useState } from 'react';
import Layout from '../../components/Layout';

import { passwordSchema } from '../../context/AuthContext';
import PasswordHelper from '../../components/PasswordHelper';
import SEO from '../../components/seo';

const ChangePassword = () => {
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const handleSave = async (values, { setSubmitting, resetForm }) => {
        const { password, old_password } = values;
        try {
            const user = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(user, old_password, password);
            setSubmitting(false);
            setSuccess('success');
            setTimeout(() => {
                setSuccess(null);
                resetForm();
            }, 3000);
        } catch (e) {
            setSuccess('error');
            setSubmitting(false);
            setError(e);
        }
    };

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
        initialValues: {
            password: '',
            old_password: ''
        },
        validationSchema: object().shape({
            password: string()
                .required('New password is required.')
                .test(
                    'is-valid',
                    'Must Contain at least 12 Characters, one (1) uppercase letter, one (1) lowercase letter, and one (1) Number',
                    (value) => passwordSchema.validate(value)
                ),
            old_password: string().required('Old password is required')
        }),
        onSubmit: handleSave
    });

    return (
        <Layout>
            <SEO title="Change Password" />
            <div className="page-header">
                <h1>Change Password</h1>
            </div>

            <p>
                <Link to="/account">Back to Account</Link>
            </p>

            <div className="row">
                <div className="col-xs-12 col-lg-7 mb-4">
                    <PasswordHelper password={values.password} />
                </div>
                <form className="col-xs-12 col-lg-7" onSubmit={handleSubmit} noValidate>
                    <Input
                        id="old_password"
                        label="Current Password"
                        type="password"
                        value={values.old_password}
                        error={errors.old_password}
                        touched={touched.old_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                    />
                    <Input
                        id="password"
                        label="New Password"
                        type="password"
                        value={values.password}
                        error={errors.password}
                        touched={touched.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                    />
                    <StatusButton successState={success} label="Save" />
                    {error && <p>Error saving password.</p>}
                </form>
            </div>
        </Layout>
    );
};

export default ChangePassword;
